// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 768px)";
var _4 = "root-2Nk8F";
var _5 = "actionText-g1B5q";
var _6 = "root_old-2-h8U";
var _7 = "root_disabled-px9Jh";
var _8 = "root_refund-2R1dr";
var _9 = "root_farelock-3QHjH";
var _a = "switch_wrapper-2G0D7";
var _b = "info-1H-Yg";
var _c = "price_wrapper-PL6zI";
var _d = "price_label-vJiku";
var _e = "price-1yYpg";
var _f = "switch_root-2Dtce";
export { _1 as "__esModule", _2 as "mobile", _3 as "tabletMiddle", _4 as "root", _5 as "actionText", _6 as "root_old", _7 as "root_disabled", _8 as "root_refund", _9 as "root_farelock", _a as "switch_wrapper", _b as "info", _c as "price_wrapper", _d as "price_label", _e as "price", _f as "switch_root" }
export default { "__esModule": _1, "mobile": _2, "tabletMiddle": _3, "root": _4, "actionText": _5, "root_old": _6, "root_disabled": _7, "root_refund": _8, "root_farelock": _9, "switch_wrapper": _a, "info": _b, "price_wrapper": _c, "price_label": _d, "price": _e, "switch_root": _f }
